// src/components/assets/AssetHeader.tsx
import React from 'react';
import { Plus, TrendingUp, RefreshCw } from 'lucide-react';

interface AssetHeaderProps {
  totalAssets: number;
  recordCount: number;
  apiLoading: boolean;
  onAdd: () => void;
  formatCurrency: (value: number | string) => string;
}

const AssetHeader: React.FC<AssetHeaderProps> = ({ totalAssets, recordCount, apiLoading, onAdd, formatCurrency }) => {
  return (
    <>
      {/* Desktop Header */}
      <div className="hidden md:block">
        <div className="p-4 md:p-6 text-black">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex gap-3">
              <div className="bg-green-600 text-white p-3 md:p-4 rounded-full">
                <TrendingUp className="w-6 h-6 md:w-8 md:h-8" />
              </div>
              <div>
                <h2 className="text-2xl md:text-3xl font-medium mt-2 mb-2">
                  Assets / <span className="text-lg font-bold">{formatCurrency(totalAssets)}</span>
                </h2>
                <div className="flex items-center gap-2 text-sm">
                  <span>{recordCount} records</span>
                  {apiLoading && <RefreshCw className="w-4 h-4 animate-spin" />}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 md:gap-3 w-full md:w-auto justify-start md:justify-end">
              <button onClick={onAdd} className="bg-green-600 text-white py-2 px-4 md:py-3 md:px-6 rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center shadow-lg text-sm md:text-base">
                <Plus className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                Add Asset
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="md:hidden p-2">
        <div className="mt-[-50px] bg-white rounded-2xl p-2 grid grid-cols-3 gap-4 animate-fadeIn">
          <div className="flex flex-col items-center justify-center bg-green-100 text-green-800 font-semibold py-3 rounded-xl shadow-md">
            <span className="text-xs">{recordCount} records</span>
            {apiLoading && <RefreshCw className="w-4 h-4 animate-spin" />}
          </div>
          <div className="flex flex-col items-center justify-center bg-green-100 text-green-800 font-semibold p-3 rounded-xl shadow-md min-h-[60px]">
            <span className="text-xs text-center break-words">{formatCurrency(totalAssets)}</span>
          </div>
          <button onClick={onAdd} className="flex flex-col items-center justify-center bg-green-100 hover:bg-green-200 text-green-800 font-semibold py-3 rounded-xl shadow-md transform hover:scale-105 transition duration-300">
            <Plus className="w-4 h-4 mb-1" />
            <span className="text-xs">Add</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default AssetHeader;